<template>

    <div class="outer-wrapper">

        <div class="left-wrap">

            <div class="left-info">
            </div>
        </div>

        <div class="right-wrap">

            <div class="right-buttons">

                <keep-alive>

                    <component :is=" currentButtons " @switchTo=" contextChange "></component>
                </keep-alive>
            </div>

            <div class="bottom-logo">

                Some Message Logo
            </div>
        </div>
    </div>

</template>

<script>

    import OrdersAndMenu from '../misc/merchantButtons/OrdersAndMenu';
    import MenuOptions from '../misc/merchantButtons/MenuOptions';
    import OrdersOptions from '../misc/merchantButtons/OrdersOptions';

    export default {

        name: 'merchant-dashboard',
        data: () => {

            return {

                currentButtons  : 'orders-and-menu',
            }
        },
        methods: {

            contextChange( component ){

                if( component === null ) console.log( 'no component plugged in yet..' );
                else this.currentButtons = component;
            }
        },
        computed: {

        },
        components: {

            OrdersAndMenu,
            MenuOptions,
            OrdersOptions
        }
    }

</script>

<style scoped>

    a {

        color: white;
    }

    .outer-wrapper {

        display: flex;
        height: 100%;
    }

    .left-wrap, .left-info {

        display: none;
    }
    .left-info{

        height: 100%;
        width: 100%;
    }
    .right-wrap {

        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex: 1;

        box-sizing: border-box;
    }

    .right-buttons {

        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 485px;
    }
    .bottom-logo {

        text-align: center;
    }

    @media screen and ( min-width: 420px ){

        .left-wrap {

            display: flex;
            align-items: center;
            width: 5%;
            border-right: 1px solid #ccc;
        }

        .left-info {

            content: "";
        }
    }

    @media screen and ( min-width: 450px ){

        .left-wrap {

            width: 10%;
        }
    }

    @media screen and ( min-width: 480px ){

        .left-wrap {

            width: 15%;
        }
    }

    @media screen and ( min-width: 750px ){

        .left-wrap {

            width: 45%;
        }
        .left-info {

            display: block;
            background: url( "https://www.climbinggriermountain.com/wp-content/uploads/2017/04/Chipotle-Hummus-Jackfruit-Toast-with-Fresh-Herbs-www.climbinggriermountain.com_.-I-500x722.jpg" );
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }
    }

</style>